/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Roles_EditInputs */

const cs_clients_roles_edit = /** @type {(inputs: Clients_Roles_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit role`)
};

const en_clients_roles_edit = /** @type {(inputs: Clients_Roles_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit roles`)
};

/**
* | output |
* | --- |
* | "Edit roles" |
*
* @param {Clients_Roles_EditInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_roles_edit = /** @type {((inputs?: Clients_Roles_EditInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Roles_EditInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_roles_edit(inputs)
	return cs_clients_roles_edit(inputs)
});